import { useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

type GetButterflyAccessPointsRequest = {
  buildingId: number
}

export type ButterflyAccessPoint = {
  id: string
  name: string
}

export const getButterflyAccessPointsQueryKey = (data: GetButterflyAccessPointsRequest) => [
  'useGetButterflyAccessPoints',
  data,
]

const getButterflyAccessPoints = async (data: GetButterflyAccessPointsRequest) => {
  const response = await authAPI.get<ButterflyAccessPoint[]>(
    `/butterfly/access-points/${data.buildingId}`,
  )
  return response.data
}

export const useGetButterflyAccessPoints = (data: GetButterflyAccessPointsRequest) =>
  useQuery({
    enabled: Boolean(data.buildingId),
    queryFn: () => getButterflyAccessPoints(data),
    queryKey: getButterflyAccessPointsQueryKey(data),
  })
